import $http from './http'
import config from './config'

export default {
  name: 'system',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getConsumers(data) {
    return $http.post(this.getUrl("/RoleInfo/getConsumers"), data);
  },
  getRoleInfo(data) {
    return $http.post(this.getUrl("/RoleInfo/Details"), data);
  },
  getSiteInfo() {
    return $http.get(this.getUrl(`/Security/GetSiteInfo`));
  },
  getRoleList(data) {
    return $http.post(this.getUrl("/RoleInfo/List"), data);
  },
  login(loginInfo) {
    return $http.post(this.getUrl("/Security/Login"), loginInfo);
  },
  saveRoleInfo(data) {
    return $http.post(this.getUrl("/RoleInfo/Update"), data);
  },
  getTicketInfo(options) {
    return $http.post(this.getUrl("/Security/GetTicketInfo"), "", options);
  },
  // getInvoice() {
  //   return $http.get(this.getUrl(`/Invoice/InvoiceList`));
  // },
  logout() {
    return $http.post(this.getUrl("/Security/Logout"), "");
  },
  // getValidImageUrl() {
  //   return `${this.getUrl("/Security/ValidCode")}?${Math.random()}`;
  // },


  // getAddressList(data) {
  //   return $http.post(this.getUrl(`/AddressInfo/List`), data);
  // },
  // getAddressInfo(AddressID) {
  //   return $http.get(this.getUrl(`/AddressInfo/Details/${AddressID}`));
  // },

  // saveAddressInfo(data) {
  //   return $http.post(this.getUrl(`/AddressInfo/Update`), data);
  // },



  // getAddress(id) {
  //   return $http.get(this.getUrl(`/Address/AddressList/${id}`));
  // },
  // saveAddress(data) {
  //   return $http.post(this.getUrl('/Address/Save'), data);
  // },
  // Updateaddress(id) {
  //   return $http.get(this.getUrl(`/Address/UpdateDefult/${id}`));
  // },

  sendCode(UserAct) {
    return $http.post(this.getUrl(`/Security/SendCode`), UserAct);
  },
  sendValidCode(data) {
    return $http.post(this.getUrl(`/Security/SendValidCode`), data);
  },
  register(data) {
    return $http.post(this.getUrl('/Security/Register'), data);
  },
  getFlowInfo(FlowID) {
    return $http.get(this.getUrl(`/FlowInfo/Details/${FlowID}`));
  },
  getContactList(data) {
    return $http.post(this.getUrl(`/ContactInfo/List`), data);
  },
  getContactInfo(ContactID) {
    return $http.get(this.getUrl(`/ContactInfo/Details/${ContactID}`));
  },
  saveContactInfo(data) {
    return $http.post(this.getUrl(`/ContactInfo/Update`), data);
  },
  deleteContactInfo(ContactID) {
    return $http.get(this.getUrl(`/ContactInfo/Delete/${ContactID}`));
  },
  deleteRoleInfo(id,spaceId,ownerType) {
    return $http.get(this.getUrl(`/RoleInfo/Delete/${id}?spaceId=${spaceId}&ownerType=${ownerType}`));
  },
  checkAccount(data) {
    return $http.post(this.getUrl(`/Security/CheckAccount`), data);
  },
  checkCode(data) {
    return $http.post(this.getUrl(`/Security/checkCode`), data);
  },
  sendValidCode(data) {
    return $http.post(this.getUrl(`/Security/SendValidCode`), data);
  },
  resetPwd(data) {
    return $http.post(this.getUrl('/Security/ResetPwd'), data);
  },
  getInvoiceList(data) {
    return $http.post(this.getUrl(`/InvoiceInfo/List`), data);
  },
  saveInvoiceInfo(data) {
    return $http.post(this.getUrl(`/InvoiceInfo/Update`), data);
  },
  deleteInvoiceInfo(InvoiceID) {
    return $http.get(this.getUrl(`/InvoiceInfo/Delete/${InvoiceID}`));
  },
  getAccountList(data) {
    return $http.post(this.getUrl("/UserAccount/List"), data);
  },
  initializePassword(data) {
    return $http.post(this.getUrl("/UserAccount/InitializePassword"), data);
  },
  deleteAccountInfo(UserAct) {
    return $http.get(this.getUrl(`/UserAccount/Delete?UserAct=${UserAct}`));
  },

  authSendCode(data) {
    return $http.post(this.getUrl(`/auth/SendCode`), data);
  },
  authBind(data) {
    return $http.post(this.getUrl(`/auth/Bind`), data);
  },
  getOwners(data) {
    return $http.post(this.getUrl("/RoleInfo/Owners"), data);
  },
  getConferList(data) {
    return $http.post(this.getUrl(`/ConferInfo/List`), data);
  },
  getConferInfo(data) {
    return $http.post(this.getUrl(`/ConferInfo/Details`), data);
  },
  saveConferInfo(data) {
    /**
     * @method 保存授权信息
     */
    // data = {
    //     OwnerID: 'S000000000',//获得权限的人
    //     ConferDate: '2018-12-04 09:00:00',//授予日期
    //     ExpiryDate: '2018-12-04 09:00:00',//过期日期
    // }
    return $http.post(this.getUrl(`/ConferInfo/Save`), data);
  },
  deleteConferInfo(data) {
    return $http.post(this.getUrl(`/ConferInfo/Delete`), data);
  },

  getConferInfoLists(data) {
    return $http.post(this.getUrl(`configinfo/ConfigInfoList`), data);
  },
  saveConfigInfo(data) {
    return $http.post(this.getUrl(`configinfo/ConfigInfoSave`), data);

  },
  AccountExists(data) {
    return $http.post(this.getUrl(`/Security/AccountExists`), data);
  },
  getReferInfo(id) {
    return $http.get(this.getUrl(`/auth/getReferInfo?ReferID=${id}`));
  }
}



// WEBPACK FOOTER //
// ./src/apis/systemApis.js